import {
  Button,
  Card,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";

import { getDetailKota, updKota } from "../../redux/actions/KotaActions";
import { getProvinsi } from "../../redux/actions/ProvinsiActions";

/* eslint-disable react-hooks/exhaustive-deps */
const EditKota = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const { provinsi } = useSelector(({ provinsi }) => provinsi);
  const [params, setParams] = useState({
    province_code: "",
    city_name: "",
    city_code: "",
  });
  const handleChange = ({ target: { value, name } }) => {
    setParams((pref) => ({
      ...pref,
      [name]: value,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updKota(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    }).then((res) => {
      if (res.isConfirmed && success) {
        history.goBack();
      }
    });
  };
  useEffect(() => {
    setLoading(true);
    setParams((pref) => ({
      ...pref,
      city_code: id,
    }));
    dispatch(getProvinsi({ paginate: false }));
    getDetailKota(id)
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            city_name: data?.city_name,
            province_code: data?.province_code,
          }));
        } else {
          showAlert(
            "Gagal mengambil detail data kota, coba beberapa saat lagi",
            false
          );
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil detail data kota, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  }, [id, dispatch]);

  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Edit Kota</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="py-5 px-6 border-radius-0 ">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="province_code" className="mb-4">
                      Provinsi <span className="text-danger">*</span>
                    </InputLabel>
                    <Select
                      size="small"
                      labelId="province_code"
                      value={params.province_code}
                      onChange={handleChange}
                      variant="outlined"
                      className="w-full"
                      name="province_code"
                      displayEmpty
                    >
                      <MenuItem value="" selected>
                        Provinsi
                      </MenuItem>
                      {provinsi?.map((item) => (
                        <MenuItem
                          value={item.province_code}
                          key={item.province_code}
                        >
                          {item.province_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <InputLabel htmlFor="city_name" className="mb-4">
                      Kota <span className="text-danger">*</span>
                    </InputLabel>
                    <TextValidator
                      id="city_name"
                      placeholder="Kota"
                      className="w-full"
                      variant="outlined"
                      onChange={handleChange}
                      type="text"
                      name="city_name"
                      value={params.city_name || ""}
                      validators={["required"]}
                      errorMessages={["Masukkan Kota terlebih dahulu"]}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid
                      container
                      spacing={2}
                      justifyContent="flex-end"
                      className="flex-column-reverse flex-md-row"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          color="primary"
                          className="text-primary w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                          onClick={() => history.goBack()}
                        >
                          Batal
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          className="text-white w-full radius-6 text-capitalize py-2"
                          disableElevation
                          disabled={submit}
                        >
                          {submit ? (
                            <CircularProgress color="primary" size={25} />
                          ) : (
                            "Simpan"
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default EditKota;
